import { combineReducers } from 'redux'

// Partner Site
import partnerSiteSelection from 'containers/Admin/PartnerSite/PartnerSiteSelection/reducer'
import partnerSite from 'containers/Admin/PartnerSite/PartnerSite/reducer'
import partnerSiteAddDialog from 'containers/Admin/PartnerSite/PartnerSiteAddDialog/reducer'
import {
  siteRolesReducer as siteRoles,
  siteRolesChangeReducer as siteRolesChanges,
} from 'containers/Admin/PartnerSite/PartnerSiteRole/reducer'
import partnerSiteProductFamily from 'containers/Admin/PartnerSite/PartnerSiteProductFamily/reducer'

// Product
import productSelection from 'containers/Admin/Product/ProductSelection/reducer'
import product from 'containers/Admin/Product/Product/reducer'
import {
  productRolesReducer as productRoles,
  productRolesChangeReducer as productRolesChanges,
} from 'containers/Admin/Product/ProductRole/reducer'

// Users
import userRoles from 'containers/Admin/User/UserRole/reducer'
import userSelection from 'containers/Admin/User/UserSelection/reducer'
import user from 'containers/Admin/User/User/reducer'

// Client
import clientSite from 'containers/Admin/Client/ClientSiteDialog/reducer'
import clientSelection from 'containers/Admin/Client/ClientSelection/reducer'
import createClient from 'containers/Admin/Client/ClientDialog/reducer'
import client from 'containers/Admin/Client/Client/reducer'

// Parts library
import partsLibrary from 'containers/Admin/PartsLibrary/reducer'

export default combineReducers({
  partnerSiteSelection,
  partnerSiteProductFamily,
  siteRoles,
  siteRolesChanges,
  partnerSite,
  partnerSiteAddDialog,
  productSelection,
  productRoles,
  productRolesChanges,
  product,
  userRoles,
  userSelection,
  user,
  createClient,
  clientSelection,
  clientSite,
  client,
  partsLibrary
})
